import { SectionTypes } from "../../../../resources/modelTypes";

// Constants for height calculations
export const FULL_HEIGHT = window.innerHeight - 100;

/**
 * Enum representing all possible SwipePanel views in the mobile experience.
 * This includes both content sections and design/settings views.
 */
export enum SwipePanelView {
  // Content sections (from the Add Section list)
  Button = "Button",
  CashRegistry = "CashRegistry",
  Comments = "Comments",
  EventNameDescription = "EventNameDescription",
  Gallery = "Gallery",
  Image = "Image",
  ImageAndText = "ImageAndText",
  Registry = "Registry",
  Text = "Text",
  WebsiteURL = "WebsiteURL",

  // Design/Settings views
  EditColors = "EditColors",
  EditDesign = "EditDesign",
  EditFonts = "EditFonts",
}

/**
 * Height configuration for each SwipePanel view
 */
export const PANEL_HEIGHTS: Record<SwipePanelView, number> = {
  // Content sections - shorter panels for simple forms
  [SwipePanelView.Button]: 375,
  [SwipePanelView.EventNameDescription]: 350,
  [SwipePanelView.Text]: 450,
  [SwipePanelView.WebsiteURL]: 375,

  // Content sections - full height for complex forms
  [SwipePanelView.CashRegistry]: FULL_HEIGHT,
  [SwipePanelView.Comments]: FULL_HEIGHT, // Technically unused
  [SwipePanelView.Gallery]: FULL_HEIGHT,
  [SwipePanelView.Image]: FULL_HEIGHT,
  [SwipePanelView.ImageAndText]: FULL_HEIGHT,
  [SwipePanelView.Registry]: 600,

  // Design views
  [SwipePanelView.EditColors]: 420,
  [SwipePanelView.EditDesign]: 600,
  [SwipePanelView.EditFonts]: 400,
};

/**
 * Maps SectionTypes to SwipePanelView for content sections
 */
export const SECTION_TYPE_TO_PANEL_VIEW: Partial<
  Record<SectionTypes, SwipePanelView>
> = {
  [SectionTypes.Anchor]: SwipePanelView.WebsiteURL,
  [SectionTypes.Button]: SwipePanelView.Button,
  [SectionTypes.CashRegistry]: SwipePanelView.CashRegistry,
  [SectionTypes.Comments]: SwipePanelView.Comments,
  [SectionTypes.Gallery]: SwipePanelView.Gallery,
  [SectionTypes.ImageAndText]: SwipePanelView.ImageAndText,
  [SectionTypes.Media]: SwipePanelView.Image,
  [SectionTypes.Registry]: SwipePanelView.Registry,
  [SectionTypes.Text]: SwipePanelView.Text,
};

/**
 * Gets the optimal height for a panel view
 */
export const getPanelHeight = (view: SwipePanelView): number => {
  return PANEL_HEIGHTS[view];
};

/**
 * Converts a SectionType to a SwipePanelView
 * Defaults to Text panel view if no mapping exists
 */
export const sectionTypeToSwipePanelView = (
  sectionType: SectionTypes,
): SwipePanelView => {
  return SECTION_TYPE_TO_PANEL_VIEW[sectionType] ?? SwipePanelView.Text;
};
